import { apiClient, handleResponse } from './axios';

async function getAllCodes() {
  const url = '/code/';
  try {
    const response = await apiClient.get(url);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getCodesByCompanyId(companyId) {
  const url = `/code/company/${companyId}`;
  try {
    const response = await apiClient.get(url);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

const codeServices = {
  getAllCodes,
  getCodesByCompanyId,
};

export default codeServices;
